import InfiniteProgress from "components/_common/InfiniteProgress";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import reportSelectors from "redux/app/report/selectors";
import { IStore } from "redux/store";

const emfUsageHeaders = [
	"S.No",
	"IMO Number",
	"Vessel Name",
	"Total EMF Records",
	"Cleaning Chemicals",
	"Refrigerants",
	"VOC/NMVOC",
	"Packaging",
];

type OwnProps = {};
type EmfUsageTableProps = PropsFromRedux & OwnProps;
function EmfUsageTable(props: EmfUsageTableProps) {
	let { emfFleetUsageData, jobToLoadEmfFleetUsageData } = props;
	let updatedDataSet: any = [];
	if (emfFleetUsageData) {
		updatedDataSet = emfFleetUsageData.map((record) => {
			const updatedRecord: any = { ...record };
			const { emfRecords } = record;
			if (emfRecords.length > 0) {
				emfRecords.forEach((emfRecord) => {
					updatedRecord[emfRecord._id] = emfRecord.count;
				});
			}
			return updatedRecord;
		});
	}

	const handleExportCSV = () => {
		if (!updatedDataSet || !updatedDataSet.length) return;

		// Generate CSV content
		const rows = updatedDataSet.map((row: any, index: number) => {
			return [
				index + 1,
				row.imoNumber,
				row.vesselName,
				row.emfRecordCount,
				row.CLEANING_CHEMICALS ? row.CLEANING_CHEMICALS : 0,
				row.REFRIGERANTS ? row.REFRIGERANTS : 0,
				row.VOC_NMVOC ? row.VOC_NMVOC : 0,
				row.PACKAGING ? row.PACKAGING : 0,
			]
				.map((val) => {
					const str = String(val);
					return str.includes(",") ? `"${str}"` : str;
				})
				.join(",");
		});

		// Add headers
		const csvContent = [emfUsageHeaders.join(","), ...rows].join("\n");

		// Create and trigger download
		const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
		const link = document.createElement("a");
		const url = URL.createObjectURL(blob);
		link.setAttribute("href", url);
		link.setAttribute("download", `emf_usage.csv`);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	if (jobToLoadEmfFleetUsageData.isLoading) {
		console.log(jobToLoadEmfFleetUsageData.isLoading);
		return <div className="flex justify-center mt-20">Loading...</div>;
	}

	if (emfFleetUsageData.length <= 0) {
		return (
			<div className="flex justify-center items-center mt-20">
				No data found
			</div>
		);
	}

	return (
		<div className="px-4">
			<div className="flex justify-end mb-4">
				<button
					className="p-3 px-6 py-1 mt-1 mr-1 text-base text-indigo-700 border border-indigo-600 rounded-sm outline-none ws-button-og"
					disabled={!emfFleetUsageData || emfFleetUsageData.length === 0}
					title={"Export data as CSV"}
					onClick={handleExportCSV}
				>
					<span className="mr-3 text-sm">Export Data</span>
					<span className="mb-0.5 text-sm bp3-icon bp3-icon-download"></span>
				</button>
			</div>
			<InfiniteProgress
				isLoading={jobToLoadEmfFleetUsageData.isLoading}
				isSpacedOut={false}
			/>
			<table
				id="emf-usage-table"
				className="w-full h-full border border-gray-400 table-auto rounded-md font-redhat-text  overflow-auto  border-collapse text-center"
			>
				<thead>
					<tr>
						{emfUsageHeaders.map((headerLabel) => (
							<th
								key={headerLabel}
								className="px-3 py-3 text-sm border font-medium leading-4 tracking-wide text-center text-gray-700 bg-gray-100 border-b border-gray-300"
							>
								{headerLabel}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{updatedDataSet.map((row: any, index: number) => {
						return (
							<tr
								key={index}
								className={
									row.emfRecordCount === 0 ? "border-2 border-red-500" : ""
								}
							>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{index + 1}
								</td>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{row.imoNumber}
								</td>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{row.vesselName}
								</td>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{row.emfRecordCount}
								</td>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{row.CLEANING_CHEMICALS ? row.CLEANING_CHEMICALS : 0}
								</td>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{row.REFRIGERANTS ? row.REFRIGERANTS : 0}
								</td>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{row.VOC_NMVOC ? row.VOC_NMVOC : 0}
								</td>
								<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
									{row.PACKAGING ? row.PACKAGING : 0}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const reportStore = reportSelectors._getStore(store);
	const emfFleetUsageData = reportSelectors.getEmfFleetUsageData(reportStore);

	const jobToLoadEmfFleetUsageData =
		reportSelectors.jobToLoadEmfFleetUsageData(reportStore);

	return {
		emfFleetUsageData,
		jobToLoadEmfFleetUsageData,
	};
}

const reduxConnector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(EmfUsageTable);
